import { createNotesContextProvider } from 'src/SharedCommonContext/GenericNotesContextFactory';

export const {
  NotesProvider: AssetNotesProvider,
  useNotesDataFromContext: useAssetNotesDataFromContext,
  useNotesActionsFromContext: useAssetNotesActionsFromContext,
} = createNotesContextProvider({
  itemType: 'Asset',
  displayName: 'asset',
});
